module.exports = __webpack_public_path__ + "img/bg_avatar_male_71.850bc4ce.png";